<template>
	<el-container style="height: 100%">
		<el-aside style="height: 100%;overflow: hidden;width: auto;background: #545c64;"><common-aside></common-aside></el-aside>
		<el-container>
			<el-header><common-header></common-header></el-header>
			<!--加入CommonTab-->
			<common-tab></common-tab>
			<el-main>
				<transition name="fade" mode="out-in">
					<keep-alive>
					<router-view />
					</keep-alive>
				</transition>
			</el-main>
			<!-- <el-footer></el-footer> -->
		</el-container>
	</el-container>
</template>

<script>
import CommonAside from '../components/CommonAside';
import CommonTab from '../components/CommonTab';
import CommonHeader from '../components/CommonHeader';
export default {
	components: {
		CommonAside,
		CommonHeader,
		CommonTab
	},
	data() {
		return {
			transitionName: ''
		};
	},
	create() {},
	mounted() {},
	methods: {},
	watch: {
		//使用watch 监听$router的变化
		$route(to, from) {
			const routeDeep = ['/'];
			const toDepth = routeDeep.indexOf(to.path);
			const fromDepth = routeDeep.indexOf(from.path);
			this.transitionName = toDepth > fromDepth ? 'slide-left' : 'slide-right';
		}
	}
};
</script>

<style lang="scss" scoped>
.el-header {
	background-color: #333;
}
.el-main {
	overflow-x: hidden;
	width: 100%;
	position: relative;
	padding: 0 20px;
}
.fade-enter {
	opacity: 0;
}

.fade-leave {
	opacity: 1;
}

.fade-enter-active {
	transition: opacity 0.5s;
}

.fade-leave-active {
	opacity: 0;

	transition: opacity 0.5s;
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
	transition: opacity 0.3s;
	overflow: hidden;
}
.slide-right-enter {
	opacity: 0;
	transform: translateX(30px);
}
.slide-right-leave-active {
	opacity: 0;
	transform: translateX(30px);
}
.slide-left-enter {
	opacity: 0;
	transform: translateX(30px);
}
.slide-left-leave-active {
	opacity: 0;
	transform: translateX(30px);
}
.el-checkbox, .el-checkbox__input{
	position: unset;
}
</style>
